

import React from "react";
import { Box, Typography } from "@mui/material";

const CustomTableContainer = ({ children, colors }) => {
  return (
    <Box
      gridColumn="span 9"
      gridRow="span 2"
      alignItems="center"
      justifyContent="center"
      padding={1} // Reduced padding for a tighter layout
      sx={{
        "& .MuiTable-root": {
          border: "none",
          size: "small", // Compact table
        },
        "& .MuiTableCell-root": {
          borderBottom: "none",
          border: "1px solid",
          borderColor: `${colors.primary[400]} !important`,
          padding: "2px", // Tighter padding for cells
          fontSize: "14px", // Reduced font size for compactness

          // 👇 added ellipsis defaults
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        },
        "& .name-column--cell": {
          color: colors.greenAccent[300],
          padding: "1px", // Further reduced padding for name column cells
        },
        "& .MuiTableHead-root": {
          borderBottom: "none",
          backgroundColor:colors.primary[400],
        },
        "& .MuiTableBody-root": {
          overflowY: "auto",
        },
        "& .MuiCheckbox-root": {
          color: `${colors.blueAccent[500]} !important`,
          size: "small", // Reduced checkbox size
          padding: "1px", // Minimal padding around checkboxes
        },
        "& .MuiTableFooter-root": {
          borderTop: "none",
          backgroundColor: colors.blueAccent[700],
          height: "6px", // Slightly reduced footer height
        },
        "& .MuiButton-text": {
          color: `${colors.grey[100]} !important`,
          fontSize: "12px", // Smaller button text for uniformity
        },
      }}
    >

      {children}
    </Box>
  );
};

export default CustomTableContainer;

